import {getDescriber} from './descriptor/DescriptorType';

export type DiscountCodeProps = {
  location?: {
    locationFeatures?: {
      is365PayAfterTaxPromo?: boolean;
    };
  };
  consumerRoleButton?: string;
  addDiscountToCart?: () => void;
  hasConsumerRoles?: boolean;
  consumerRoleIdentifier?: {
    value?: string;
  };
  validateDiscountCode?: () => void;
  discountCodeButtonAction?: () => void;
  saveDiscountCode?: (discountCode?: string) => void;
  showErrorMsg?: boolean;
  showSuccessMsg?: boolean;
  changeToDefaultDiscount?: boolean;
  onChangeBtnPress?: () => void;
};

const DiscountCode = getDescriber().DiscountCode;

export default DiscountCode;
